import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserSession
} from "amazon-cognito-identity-js";
import { Config, CognitoIdentityCredentials } from "aws-sdk";

export default class Cognito {
  configure(config) {
    if (config.userPool) {
      this.userPool = config.userPool;
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId,
        Storage: sessionStorage
      });
    }
    Config.region = config.Region;
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId
    });
    this.options = config;
    this.currentUser = false;
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, "$cognito", {
      get() {
        return this.$root._cognito;
      }
    });

    Vue.mixin({
      beforeCreate() {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito;
          this._cognito.configure(options);
        }
      }
    });
  };

  /**
   * ログイン
   * @param username ユーザーID
   * @param password ユーザーパスワード
   * @param loginSaveState ユーザーID保存有無
   */
  login(username, password, loginSaveState) {
    const userData = {
      Username: username,
      Pool: this.userPool,
      Storage: sessionStorage
    };
    const cognitoUser = new CognitoUser(userData);
    const authenticationData = { Username: username, Password: password };
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => {
          // ログインID保存処理
          loginSaveState
            ? localStorage.setItem("safer_user_id", username)
            : localStorage.removeItem("safer_user_id");

          resolve(result);
        },
        onFailure: err => {
          reject(err);
        }
      });
    });
  }

  // ログアウト
  logout() {
    // -------------------------------------------------------
    // Cognito認証なしモードの場合には、ログアウト処理をスキップ
    if (process.env.VUE_APP_COGNITO === "invalid") {
      return;
    }
    // -------------------------------------------------------
    if (this.userPool.getCurrentUser()) {
      this.userPool.getCurrentUser().signOut();
    }
  }

  // 認証済か否か
  isAuthenticated() {
    // -------------------------------------------------------
    // Cognito認証なしモードの場合には、ログイン成功のふりをする
    if (process.env.VUE_APP_COGNITO === "invalid") {
      return new Promise(resolve => {
        resolve();
      });
    }
    // -------------------------------------------------------
    this.currentUser = this.userPool.getCurrentUser();
    return new Promise((resolve, reject) => {
      if (this.currentUser === null) {
        reject(this.currentUser);
      }

      // セッションストレージにログイン情報が存在有無チェック
      this.currentUser.getSession((err, session) => {
        // ログイン情報取得チェック
        if (err) {
          // ログイン情報取得失敗
          reject(err);
        } else {
          // ログイン情報取得成功
          // ログイン情報のセッションの有効性チェック
          if (!session.isValid()) {
            // ログイン失敗
            reject(session);
          } else {
            // ログイン成功
            resolve(session);
          }
        }
      });
    });
  }

  // 属性の取得
  getAttribute() {
    return new Promise((resolve, reject) => {
      this.currentUser.getUserAttributes((err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    });
  }

  static isCognitoUserSession(session) {
    return session instanceof CognitoUserSession;
  }
}
